import { render, staticRenderFns } from "./ExtendItem.vue?vue&type=template&id=343c3ff5&scoped=true"
import script from "./ExtendItem.vue?vue&type=script&lang=js"
export * from "./ExtendItem.vue?vue&type=script&lang=js"
import style0 from "./ExtendItem.vue?vue&type=style&index=0&id=343c3ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343c3ff5",
  null
  
)

export default component.exports